
import DateTimeUtils from '~/components/FileViewerModules/Chattable/Mixins/DateTimeUtils'

export default {
    name: 'ChatRoom',
    mixins: [DateTimeUtils],
    props: {
        room: {
            type: Object,
            required: false
        },
        meta: {
            type: Object,
            required: false
        },
        isOpen: {
            type: Boolean,
            default: () => false
        },
        skeleton: {
            type: Boolean,
            default: () => false
        }
    }
}
